import styled from 'styled-components';

import { spaceL, spaceXL } from '@xing-com/tokens';
import { Headline as InnerHeadline } from '@xing-com/typography';

import { BaseButton as InnerBaseButton } from '../../components/base-button';

export const TeampermissionsButton = styled(InnerBaseButton)`
  padding-left: 0;
  white-space: nowrap;
  @media (--mediaHandheld) {
    display: none;
  }
`;

export const BrandmanagerButton = styled(InnerBaseButton)`
  margin-left: auto;
  @media (--mediaHandheld) {
    display: none;
  }
`;

export const Headline = styled(InnerHeadline)<$TSFixMe>`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceL};
`;
